<template>
    <div>
        <h4 class="mb-base">Sync Offline Data</h4>
        <vs-tabs>
            <vs-tab label="Issue">
                <div>
                    <vs-table class="freeze_row row2" :data="Object.keys(issue_type)" slot="no-body" :hoverFlat="true" stripe v-if="start_process">
                        <vs-tr>
                            <vs-th>Module</vs-th>
                            <vs-th>Status</vs-th>
                        </vs-tr>
                        <template>
                            <template v-for="(item, index) in Object.keys(issue_type)">
                                <vs-tr :key="index">
                                    <vs-td>{{ issue_type[item] }}</vs-td>
                                    <vs-td>
                                        <template v-if="data[item]['is_syncing']">
                                            <vx-tooltip text= "Processing" color="primary">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-primary" :icon="spinnerIcon" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="!data[item]['is_syncing'] && data[item]['is_waiting']">
                                            <vx-tooltip text= "Waiting" color="warning">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-warning" :icon="clockIcon" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="!(data[item]['is_syncing'] || data[item]['is_waiting']) && data[item]['draft'] > 0">
                                            <vx-tooltip text= "Failed" color="danger">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-danger" :icon="exclamationIcon" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="!(data[item]['is_syncing'] && data[item]['is_waiting']) && (data[item]['completed'] == data[item]['total_payload'])">
                                            <vx-tooltip text= "Success" color="success">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-success" :icon="checkIcon" />
                                            </vx-tooltip>
                                        </template>&ensp;
                                        {{ data[item]['draft'] + data[item]['completed'] }}/{{ data[item]['total_payload'] }},&ensp;
                                        <router-link :to="{name: 'cache-list', params: {issue_type: item}, query: {is_failed: true}}">
                                            Failed: {{ data[item]['draft'] }}
                                        </router-link>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </template>
                    </vs-table>
                </div>
            </vs-tab>
            <vs-tab label="DPR Issue">
                <div>
                    <vs-table class="freeze_row row2" :data="Object.keys(dpr_issue_type)" slot="no-body" :hoverFlat="true" stripe v-if="start_process">
                        <vs-tr>
                            <vs-th>Module</vs-th>
                            <vs-th>Status</vs-th>
                        </vs-tr>
                        <template>
                            <template v-for="(item, index) in Object.keys(dpr_issue_type)">
                                <vs-tr :key="index">
                                    <vs-td>{{ dpr_issue_type[item] }}</vs-td>
                                    <vs-td>
                                        <template v-if="dpr_issue_data[item]['is_syncing']">
                                            <vx-tooltip text= "Processing" color="primary">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-primary" :icon="spinnerIcon" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="!dpr_issue_data[item]['is_syncing'] && dpr_issue_data[item]['is_waiting']">
                                            <vx-tooltip text= "Waiting" color="warning">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-warning" :icon="clockIcon" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="!(dpr_issue_data[item]['is_syncing'] || dpr_issue_data[item]['is_waiting']) && dpr_issue_data[item]['draft'] > 0">
                                            <vx-tooltip text= "Failed" color="danger">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-danger" :icon="exclamationIcon" />
                                            </vx-tooltip>
                                        </template>
                                        <template v-else-if="!(dpr_issue_data[item]['is_syncing'] && dpr_issue_data[item]['is_waiting']) && (dpr_issue_data[item]['completed'] == dpr_issue_data[item]['total_payload'])">
                                            <vx-tooltip text= "Success" color="success">
                                                <font-awesome-icon style="font-size: 1.2em;" class="text-success" :icon="checkIcon" />
                                            </vx-tooltip>
                                        </template>&ensp;
                                        {{ dpr_issue_data[item]['draft'] + dpr_issue_data[item]['completed'] }}/{{ dpr_issue_data[item]['total_payload'] }},&ensp;
                                        <router-link :to="{name: 'cache-dpr-entries', params: {issue_type: dpr_issue_data[item]['issue_type'], module_key: item}, query: {is_failed: true}}">
                                            Failed: {{ dpr_issue_data[item]['draft'] }}
                                        </router-link>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </template>
                    </vs-table>
                </div>
            </vs-tab>
        </vs-tabs>

        <!-- popup  -->
        <vs-popup class="sync-popup" :active.sync="manual_sync_popup">
            <h2 class="mt-1 text-center">
                <font-awesome-icon class="mr-2" :icon="cloudIcon"/>
                Synchronize
            </h2>
            <h5 class="mt-4 mb-base text-center">You are back online, do you want to initiate sync for offline data now?</h5>
            <div class="text-center mb-3">
                <vs-button @click="() => {
                    manual_sync_popup=false
                    sync_data()
                }" color="primary" size="small" type="filled" class="mr-3">Sync</vs-button>
                <vs-button @click="manual_sync_popup=false" size="small" color="danger" type="filled">Cancel</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import { Request } from '../utils/requests'
import { faSpinner, faCheckCircle, faExclamationTriangle, faClock, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';

export default {
    data() {
        return {

            issue_type: {
                routine_maintenance: 'Routine Maintenance',
                major_maintenance: 'Major Maintenance',
                electrical_maintenance: 'Electrical Maintenance',
                highway: 'Corrective Maintenance',
                road_user_accident: 'Road User Accident',
                occupational: 'Occupational',
                hazard: 'Hazard',
                vehicle_breakdown: 'Vehicle Breakdown',
                unauthorised_parking: 'Unauthorised Parking',
                traffic_violation: 'Traffic Violation',
                dead_animal_debris_removal: 'Dead Animal DebrisRemoval',
                material_damage: 'Material Damage',
                unauthorised_access: 'Unauthorised Access',
                unauthorised_media_cut: 'Unauthorised MediaCut',
                other: 'Other',
                enroachment_row: 'Enroachment Row',
            },

            data: {
                routine_maintenance: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                major_maintenance: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                electrical_maintenance: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                highway: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                road_user_accident: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                occupational: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                hazard: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                vehicle_breakdown: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                unauthorised_parking: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                traffic_violation: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                dead_animal_debris_removal: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                material_damage: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                unauthorised_access: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                unauthorised_media_cut: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                other: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
                enroachment_row: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true
                },
            },

            dpr_issue_data: {
                mm_bituminous_concrete_overlay: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_dense_bituminous_concrete_overlay: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_milling: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_thermoplastic_road_marking: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_shoulder_raising: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_road_sruds_fixing: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_kerb_topping: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_kerb_painting: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_microsurfacing: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                },
                mm_tack_coat: {
                    total_payload: 0,
                    completed: 0,
                    draft: 0,
                    is_syncing: false,
                    is_waiting: true,
                    issue_type: 'major_maintenance'
                }
            },

            dpr_issue_type: {
                mm_bituminous_concrete_overlay : 'MM Bituminous Concrete Overlay',
                mm_dense_bituminous_concrete_overlay : 'MM Dense Bituminous Concrete Overlay',
                mm_milling : 'MM Milling',
                mm_thermoplastic_road_marking : 'MM Thermoplastic Road Marking',
                mm_shoulder_raising : 'MM Shoulder Raising',
                mm_road_sruds_fixing : 'MM Road Sruds Fixing',
                mm_kerb_topping : 'MM Kerb Topping',
                mm_kerb_painting : 'MM Kerb Painting/Crash Barrier',
                mm_microsurfacing : 'MM Micro Surfacing',
                mm_tack_coat : 'MM Tack Coat',
            },

            manual_sync_popup: false,
            start_process: false
        }
    },
    created() {
        if(this.$route.query.auto_sync) {
            this.sync_data()
        } else {
            this.manual_sync_popup = true
        }
    },
    computed: {
        spinnerIcon: () => faSpinner,
        checkIcon: () => faCheckCircle,
        exclamationIcon: () => faExclamationTriangle,
        clockIcon: () => faClock,
        cloudIcon: () => faCloudUploadAlt
    },
    methods: {
        async sync_data() {
            this.start_process = true
            await this.sync_issue_data()
            await this.sync_dpr_issue_data()
        },
        async sync_issue_data() {
            let issue_list = Object.keys(this.issue_type)
            
            for(let i=0; i<issue_list.length; i++) {
                let key = `issues__${issue_list[i]}`

                //setting status
                this.data[issue_list[i]]['is_syncing'] = true
                this.data[issue_list[i]]['is_waiting'] = false

                await this.issue_sync(key, issue_list[i])
   
                //setting status
                this.data[issue_list[i]]['is_syncing'] = false
            }

            this.remove_data_from_cache('issue')
        },
        async sync_dpr_issue_data() {
            
            let dpr_issue_list = Object.keys(this.dpr_issue_type)
            
            for(let i=0; i<dpr_issue_list.length; i++) {
                let key = `dpr_issues__${dpr_issue_list[i]}`

                //setting status
                this.dpr_issue_data[dpr_issue_list[i]]['is_syncing'] = true
                this.dpr_issue_data[dpr_issue_list[i]]['is_waiting'] = false

                await this.dpr_issue_sync(key, dpr_issue_list[i])
   
                //setting status
                this.dpr_issue_data[dpr_issue_list[i]]['is_syncing'] = false
            }

            this.remove_data_from_cache('dpr_issue')
        },
        async issue_sync(key, issue_type) {
            let results = JSON.parse(await this.$ionicStorage.get(key))
            
            // if results length is zero then returning 
            if(!results || results.length == 0) return

            this.data[issue_type]['total_payload'] = results.length

            // iterating through data 
            for(let index=0; index<results.length; index++) {
                let request_method = 'POST'
                let url = this.$store.state.apiendpoints.data_issue

                if (['image_failed', 'image_uploading'].includes(results[index]['status'])) {
                    try {
                        // changing status 
                        await this.change_status_in_cache(results, index, 'image_uploading', 'issue', key, issue_type)

                        await this.upload_images(results[index]['data']['id'], results[index]['images'], index, 'issue', key, results)

                        // changing status 
                        await this.change_status_in_cache(results, index, 'success', 'issue', key, issue_type)

                    } catch(e) {
                        // changing status 
                        await this.change_status_in_cache(results, index, 'image_failed', 'issue', key, issue_type)
                    }

                } else if(['pending'].includes(results[index]['status'])) {

                    let payload = {
                        ...results[index]['data'],
                        sync_mode: results[index]['sync_mode'],
                        images: null
                    }

                    // changing status 
                    await this.change_status_in_cache(results, index, 'uploading', 'issue', key, issue_type)

                    Request(this, request_method, url, null, payload).then(
                        async res => {
                            try {

                                // saving response first
                                results[index]['data'] = res
                                await this.$ionicStorage.set(key, JSON.stringify(results))

                                // changing status 
                                await this.change_status_in_cache(results, index, 'image_uploading', 'issue', key, issue_type)

                                await this.upload_images(res.id, results[index]['images'], index, 'issue', key, results)

                                // changing status 
                                await this.change_status_in_cache(results, index, 'success', 'issue', key, issue_type)
                                
                            } catch (e) {
                                // changing status 
                                await this.change_status_in_cache(results, index, 'image_failed', 'issue', key, issue_type)
                            }
                        },
                        async err => {
                            // changing status 
                            await this.change_status_in_cache(results, index, 'draft', 'issue', key, issue_type)
                        }
                    )
                    
                } else {

                    if (results[index]['status'] == 'success') {
                        this.data[issue_type]['completed'] = this.data[issue_type]['completed'] + 1

                    } else if (results[index]['status'] == 'draft') {
                        this.data[issue_type]['draft'] = this.data[issue_type]['draft'] + 1
                    }
                }
            }

            await this.$ionicStorage.set(key, JSON.stringify(results))
        },
        async dpr_issue_sync(key, dpr_issue_type) {
            let results = JSON.parse(await this.$ionicStorage.get(key))
            
            // if results length is zero then returning 
            if(!results || results.length == 0) return

            this.dpr_issue_data[dpr_issue_type]['total_payload'] = results.length

            // iterating through data 
            for(let index=0; index<results.length; index++) {
                let request_method = 'POST'
                let url = this.$store.state.apiendpoints.dpr_entry

                if (['image_failed', 'image_uploading'].includes(results[index]['status'])) {
                    try {
                        // changing status 
                        await this.change_status_in_cache(results, index, 'image_uploading', 'dpr_issue', key, dpr_issue_type)

                        await this.upload_images(results[index]['data']['id'], results[index]['images'], index, 'dpr_issue', key, results)

                        // changing status 
                        await this.change_status_in_cache(results, index, 'success', 'dpr_issue', key, dpr_issue_type)

                    } catch(e) {
                        // changing status 
                        await this.change_status_in_cache(results, index, 'image_failed', 'dpr_issue', key, dpr_issue_type)
                    }

                } else if(['pending'].includes(results[index]['status'])) {

                    let payload = {
                        ...results[index]['data'],
                        sync_mode: results[index]['sync_mode'],
                        images: null
                    }

                    // changing status 
                    await this.change_status_in_cache(results, index, 'uploading', 'dpr_issue', key, dpr_issue_type)

                    Request(this, request_method, url, null, payload).then(
                        async res => {
                            try {

                                // saving response first
                                results[index]['data'] = res
                                await this.$ionicStorage.set(key, JSON.stringify(results))

                                // changing status 
                                await this.change_status_in_cache(results, index, 'image_uploading', 'dpr_issue', key, dpr_issue_type)

                                await this.upload_images(res.id, results[index]['images'], index, 'dpr_issue', key, results)

                                // changing status 
                                await this.change_status_in_cache(results, index, 'success', 'dpr_issue', key, dpr_issue_type)
                                
                            } catch (e) {
                                // changing status 
                                await this.change_status_in_cache(results, index, 'image_failed', key, dpr_issue_type)
                            }
                        },
                        async err => {
                            // changing status 
                            await this.change_status_in_cache(results, index, 'draft', 'dpr_issue', key, dpr_issue_type)
                        }
                    )
                    
                } else {

                    if (results[index]['status'] == 'success') {
                        this.dpr_issue_data[dpr_issue_type]['completed'] = this.dpr_issue_data[dpr_issue_type]['completed'] + 1

                    } else if (results[index]['status'] == 'draft') {
                        this.dpr_issue_data[dpr_issue_type]['draft'] = this.dpr_issue_data[dpr_issue_type]['draft'] + 1
                    }
                }
            }

            await this.$ionicStorage.set(key, JSON.stringify(results))
        },
        async change_status_in_cache(results, index, status, type, key, issue_type) {
            results[index]['status'] = status
            await this.$ionicStorage.set(key, JSON.stringify(results))

            if (type === 'issue') {
                if (status == 'success') {
                    this.data[issue_type]['completed'] = this.data[issue_type]['completed'] + 1
    
                } else if(status == 'draft') {
                    this.data[issue_type]['draft'] = this.data[issue_type]['draft'] + 1
                }

            } else if (type === 'dpr_issue') {
                if (status == 'success') {
                    this.dpr_issue_data[issue_type]['completed'] = this.dpr_issue_data[issue_type]['completed'] + 1
    
                } else if(status == 'draft') {
                    this.dpr_issue_data[issue_type]['draft'] = this.dpr_issue_data[issue_type]['draft'] + 1
                }
            }
        },
        async upload_images(issue_id, images, result_index, type, key, results) {
            for (let i=0; i<images.length; i++) {

                // if image is already uploaded then skipping it 
                if (images[i]['status'] == 'c') continue

                // this.$set(images[i], 'status', 'u')
                results[result_index]['images'][i]['status'] = 'u'
                await this.$ionicStorage.set(key, JSON.stringify(results))

                try {
                    let data = await this.upload_single_image(issue_id, images[i], type)
                    // this.$set(images[i], 'status', 'c')
                    results[result_index]['images'][i]['status'] = 'c'
                    await this.$ionicStorage.set(key, JSON.stringify(results))

                    if (data != null)
                        data['status'] = 'c'
                        results[result_index]['images'][i] = data
                        // this.$set(images, i, data)
                        await this.$ionicStorage.set(key, JSON.stringify(results))
                } catch (e) {
                    // this.$set(images[i], 'status', 'f')
                    results[result_index]['images'][i]['status'] = 'f'
                    await this.$ionicStorage.set(key, JSON.stringify(results))
                    throw e
                }
            }
        },
        async upload_single_image(issue_id, image_obj, type) {
            return new Promise((resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)

                const parts = image_obj.local_image.split(':')[1].split(';')[0]
                // Extract the base64-encoded data from the URL
                const base64Data = image_obj.local_image.split('base64,')[1];
                // Decode the base64 string back into binary data
                const binaryData = atob(base64Data);
                let u = new Uint8Array(binaryData.length)

                for(let i=0; i<binaryData.length; i++) {
                    u[i] = binaryData.charCodeAt(i)
                }
                // Convert the binary data to a Blob object
                const blob = new Blob([u], { type: parts });
                
                // Send the Blob object in the form submission
                let formData = new FormData();
                formData.append('image', blob, "image."+ parts.split('/')[1]);
                formData.append('image_type', 'p')

                let url;
                if (type === 'issue') {
                    url = this.$store.state.apiendpoints.data_issue_image

                } else if (type === 'dpr_issue') {
                    url = this.$store.state.apiendpoints.dpr_entry_image

                } else {
                    url = null
                    reject()
                }

                Request(this, 'POST', this.sprintf(url, issue_id), null, formData).then(
                    res => resolve(res),
                    err => reject(err)
                )
            })
        },
        async remove_data_from_cache(type) {
            let issue_list = []
            let issue_key = ''
            if (type === 'issue') {
                issue_list = Object.keys(this.issue_type)
                issue_key = 'issues__'

            } else if (type === 'dpr_issue') {
                issue_list = Object.keys(this.dpr_issue_type)
                issue_key = 'dpr_issues__'
            }
            
            for(let i=0; i<issue_list.length; i++) {
                let key = issue_key + `${issue_list[i]}`
                let results = JSON.parse(await this.$ionicStorage.get(key))
            
                // if results length is zero then returning 
                if(!results || results.length == 0) continue

                let success_payload = results.filter(obj => obj['status']=='success')

                if(results.length == success_payload.length) {
                    await this.$ionicStorage.remove(key)
                }

            }
        }
    }
}
</script>
